import { render, staticRenderFns } from "./Conceitos.vue?vue&type=template&id=7f3ad24e&"
import script from "./Conceitos.vue?vue&type=script&lang=js&"
export * from "./Conceitos.vue?vue&type=script&lang=js&"
import style0 from "./Conceitos.vue?vue&type=style&index=0&id=7f3ad24e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports